'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["currencyStyle", "validCurrencies", "currenciesFilter"];
import PropTypes from 'prop-types';
import UISelect from 'UIComponents/input/UISelect';
import { getCurrencyOptions } from '../internal/utils/CurrencyFormatting';
import { currencyStyles } from 'I18n/internal/utils/CurrencyLabelFormatters';
import { forwardRef } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
const CurrencySelect = /*#__PURE__*/forwardRef((props, ref) => {
  const {
      currencyStyle,
      validCurrencies,
      currenciesFilter
    } = props,
    passThroughProps = _objectWithoutPropertiesLoose(props, _excluded);
  return /*#__PURE__*/_jsx(UISelect, Object.assign({}, passThroughProps, {
    className: props.className,
    ref: ref,
    options: getCurrencyOptions({
      currencyStyle,
      currenciesFilter,
      validCurrencies
    })
  }));
});
CurrencySelect.propTypes = {
  className: PropTypes.string,
  currencyStyle: PropTypes.oneOf(Object.keys(currencyStyles)).isRequired,
  validCurrencies: PropTypes.array,
  currenciesFilter: PropTypes.func
};
CurrencySelect.defaultProps = {
  currencyStyle: currencyStyles.short
};
export default CurrencySelect;